import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrIconSelect from "UI/FnrIconSelect/FnrIconSelect";

const Icon = () => {
  const [icon, setIcon] = extendedFieldHooks.useIcon();
  const isReadOnly = extendedFieldHooks.useIsReadOnly();
  return (
    <FnrIconSelect
      selected={icon}
      onSelect={setIcon}
      data-cy="ExtendedFields_IconSelect"
      disabled={isReadOnly}
    />
  );
};

export default Icon;
